import axiosInstance from "./api";

export const createAssignment = async ({
  persona_id,
  deadline = new Date(Date.now() + 24 * 60 * 60 * 1000).toISOString(), // 1 day
  priority = 5,
  allow_partial_assignments = false,
  recipient_phone_number,
  variables,
  callback,
  topic,
  links,
  text_inactivity_timeout_minutes,
}) => {
  const now = new Date();
  const datePlusFiveDays = new Date(now);
  datePlusFiveDays.setUTCDate(now.getUTCDate() + 1);
  const getTextProperties =
    variables.modality === "text"
      ? {
          deadline: datePlusFiveDays.toISOString(),
          inactivity_timeout_minutes: text_inactivity_timeout_minutes || 300,
        }
      : null;

  const getVoiceProperties =
    variables.modality === "voice" ? { leave_voicemail: true } : null;

  const { data } = await axiosInstance.post("/api/v1/assignment", {
    persona_id: persona_id,
    deadline: deadline,
    priority: priority,
    allow_partial_assignments: allow_partial_assignments,
    recipient_phone_number: recipient_phone_number,
    modality: variables.modality,
    variables: variables,
    callback: callback,
    topic: topic,
    text_properties: getTextProperties,
    voice_properties: getVoiceProperties,
    allow_multiple_assignments: document.title
      .toLocaleLowerCase()
      .includes("local"),
    links: links,
  });
  return data;
};

export const getAssignment = async (id) => {
  const response = await axiosInstance.get(`/api/v1/assignment/get/${id}`);
  return response?.data || {};
};

export const getAssignmentsList = async (
  page = 1,
  limit = 1000,
  order_by = "created_at:desc",
  is_open = null,
  assignment_ids = null,
) => {
  const params = {
    is_open,
    order_by,
    limit,
    offset: limit * (page - 1),
    assignment_ids,
  };

  const response = await axiosInstance.get(`/api/v1/assignment/search`, {
    params,
    paramsSerializer: {
      indexes: null,
    },
  });

  return response;
};

export const cancelAssignment = async (id, reason) => {
  const response = await axiosInstance.put(`/api/assignment/cancel/${id}`, {
    state: {
      open: false,
      closed_reason: reason,
    },
  });
  return response;
};

export const cancelGroupedAssignments = async (groupId, reason) => {
  const response = await axiosInstance.put(`/api/assignment/group/${groupId}`, {
    state: {
      open: false,
      closed_reason: reason,
    },
  });
  return response;
};

export const terminateAssignment = async (id, reason, details) => {
  const response = await axiosInstance.post(`/api/assignment/${id}/terminate`, {
    state: {
      open: false,
      closed_reason: reason,
      details: details,
    },
  });
  return response;
};

export const getAssignmentJobHistories = async (
  assignment_id,
  page = 1,
  jobsPerPage = 40,
) => {
  const offset = (page - 1) * jobsPerPage;

  const response = await axiosInstance.get("/api/assignment/jobs", {
    params: {
      assignment_id: assignment_id,
      limit: jobsPerPage,
      offset: offset,
    },
    paramsSerializer: {
      indexes: null,
    },
  });
  return response?.data?.data?.items || [];
};
